module.exports = __webpack_public_path__ + "static/media/stockai.4abb28d9.png";